import { HomeCardProps } from "./types";
import { StyledCard, StyledImg } from "./styles";
import { Box, Typography, useTheme } from "@mui/material";

const  HomeCard: React.FC<HomeCardProps> = ({data, handleClick}) => {
    const theme = useTheme();

    const handleCardClick = (id: number) => {
        if(handleClick) handleClick(id);
    };

    return(
        <StyledCard theme={theme} onClick={() => handleCardClick(data.id)}>
            <Box p={1} style={{overflow: "hidden", maxWidth:"342px", maxHeight:"257px", borderRadius:"10px" }}>
                <StyledImg src={data.image} alt={data.title} width="342px" style={{maxWidth:'100%'}} height="257px"/>
            </Box>
            <Box>
                <Typography variant="h6" style={{maxWidth: "342px", whiteSpace:"break-spaces"}} >
                    {data.title}
                </Typography>
                <Typography variant="subtitle1" color="textDisabled" 
                style={{textOverflow: "ellipsis", maxWidth: "342px", overflow: "hidden", whiteSpace: "nowrap"}}>
                    {data.subtitle}
                </Typography>
            </Box>
        </StyledCard> 
    )
}

export default HomeCard;